import { white, indigo, VioletBlue } from "../../loggedout/shared-styles/Colors";

const appearance = {
  // If you are planning to extensively customize rules, use the "none"
  // theme. This theme provides a minimal number of rules by default to avoid
  // interfering with your custom rule definitions.

  // using stripe theme since elements.update function is getting deprecated on none theme which we have used to support responsive UI.
  theme: 'stripe',
  variables: {
    colorPrimary: white,
    colorText: white,
    colorDanger: '#FC6161',
    fontFamily: 'Quicksand, Helvetica, Arial, sans-serif',
    spacingUnit: '4px',
    borderRadius: '8px',
    colorTextPlaceholder: '#313575',
    spacingGridRow: '18px',
    spacingGridColumn: '18px',
  },

  rules: {
    '.Tab': {
      backgroundColor: 'rgba(0,0,0,0)',
      border: `1px solid ${VioletBlue}`,
      marginBottom: '10px',
      boxShadow: 'none',
    },

    '.Tab--selected': {
      border: `2px solid ${white}`,
      boxShadow: 'none',
    },

    '.Tab--selected:focus': {
      border: `2px solid ${white}`,
      boxShadow: 'none',
    },

    '.Label': {
      color: '#9294F6',
      fontFamily: 'var(--fontFamily)',
      textTransform: 'uppercase',
      letterSpacing: '2px',
      fontWeight: '500',
      fontSize: '12px',
    },

    '.Input': {
      color: 'var(--colorText)',
      backgroundColor: 'rgba(0,0,0,0)',
      fontWeight: '700',
      fontFamily: 'var(--fontFamily)',
      fontSize: '16px',
      border: '0px',
      borderBottom: `1px solid ${indigo}`,
      borderRadius: '0px',
      outline: 'none',
      padding: '6px',
      boxShadow: 'none',
    },

    '.Block': {
      border: '0px',
      boxShadow: 'none',
      backgroundColor: 'rgba(0,0,0,0)',
    },

    '.Input:focus': {
      boxShadow: 'none',
      border: '0px',
      borderBottom: `1px solid ${indigo}`,
      borderRadius: '0px',
    },

    '.Input--empty:focus': {
      boxShadow: 'none',
      border: '0px',
      borderBottom: `1px solid ${indigo}`,
      borderRadius: '0px',
    },

    '.Input--invalid': {
      // fontSize: '12px'
      color: `var(--colorPrimary)`,
      border: '0px',
      borderBottom: '1px solid var(--colorDanger)',
      borderRadius: '0px',
      boxShadow: 'none',
    },

    '.Input--invalid:focus': {
      border: '0px',
      borderBottom: '1px solid var(--colorDanger)',
      borderRadius: '0px',
      boxShadow: 'none',
    },

    '.Error': {
      fontSize: '12px',
      fontFamily: 'var(--fontFamily)',
      fontWeight: '500',
      color:  'var(--colorDanger)'
    },

    // '.Input::placeholder': {
    //   color: 'var(--colorTextPlaceholder)'
    // },

    // See all supported class names and selector syntax
  },
};

const fonts = [
  {
    cssSrc:
      'https://fonts.googleapis.com/css?family=Quicksand:300,400,500,700',
  },
];

let paymentElementOptions = {
  fields: {
    billingDetails: {
      email: 'auto',
      address: {
        country: 'auto',
        postalCode: 'auto',
      },
    },
  },
  terms: {
    auBecsDebit: 'never',
    bancontact: 'never',
    card: 'never',
    ideal: 'never',
    sepaDebit: 'never',
    sofort: 'never',
    usBankAccount: 'never',
  },
};

const getPaymentElementConfigurations = () => {
  return  {
    appearance,
    fonts,
    paymentElementOptions
  }
}

export default getPaymentElementConfigurations;